import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../../lib/supabase'

export interface CashierFeatureFlags {
  stampCorrectionEnabled: boolean
  rewardRestoreEnabled: boolean
}

async function fetchCashierFeatureFlags(): Promise<CashierFeatureFlags> {
  const { data, error } = await supabase.rpc('get_cashier_feature_flags')
  if (error) throw error
  const result = data as { cashier_stamp_correction_enabled: boolean; cashier_reward_restore_enabled: boolean } | null
  return {
    stampCorrectionEnabled: result?.cashier_stamp_correction_enabled ?? true,
    rewardRestoreEnabled: result?.cashier_reward_restore_enabled ?? true,
  }
}

export function useCashierFeatureFlags() {
  return useQuery({
    queryKey: ['cashier-feature-flags'],
    queryFn: fetchCashierFeatureFlags,
    staleTime: 5 * 60 * 1000,
    refetchInterval: 5 * 60 * 1000,
  })
}